import React from 'react';
export function Show() {
  return <svg
  // @ts-ignore: title does not exists in svg
  title="Show" viewBox="0 0 20 20" height="15" width="15" xmlns="http://www.w3.org/2000/svg" fill="currentColor">
      <title>Show</title>
      <path d="M.2 10a11 11 0 0119.6 0A11 11 0 01.2 10zm9.8 4a4 4 0 100-8 4 4 0 000 8zm0-2a2 2 0 110-4 2 2 0 010 4z"></path>
    </svg>;
}